<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline" size="mini">
                <el-form-item label="用户ID：" prop="uid">
                    <el-input v-model.trim="search.uid" placeholder=" " clearable @clear="Search"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass" @click="Search">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="clearCondition">重置</el-button>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" size="mini" class="btnClass" @click="showCreateDialog">创建虚拟设备</el-button>
            </div>
        </div>
        <!-- 列表 -->
        <el-table :data="list" size="mini">
            <el-table-column label="UUID" width="290">
                <template v-slot="scope">
                    <span>{{ scope.row.uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备ID" width="290">
                <template v-slot="scope">
                    <span>{{ scope.row.device_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="产品型号">
                <template v-slot="scope">
                    <span>{{ scope.row.model_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="绑定用户" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.owner_uid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备名称">
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="运行状态">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.running">运行中</span>
                    <span style="color:#FF1A2E" v-else>已停止</span>
                </template>
            </el-table-column>
            <el-table-column label="MQTT连接">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.mqtt_connected">已连接</span>
                    <span style="color:#FF1A2E" v-else>未连接</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="180">
                <template v-slot="scope">
                    <span>{{ scope.row.create_time && timeToDate(scope.row.create_time) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260px">
                <template v-slot="scope">
                    <el-button v-if="!scope.row.running" type="success" size="mini" class="btnClass"
                        style="background-color:#36C626;border-color:#36C626;"
                        @click="startDevice(scope.row)">启动</el-button>
                    <el-button v-if="scope.row.running" size="mini" class="btnClass"
                        style="background-color:#FF9900;border-color:#FF9900;"
                        @click="stopDevice(scope.row)">停止</el-button>
                    <router-link style="margin:0 6px" :to="'/iot/virtualdevice/detail/' + scope.row.uuid">
                        <el-button type="info" size="mini" class="btnClass">详情</el-button>
                    </router-link>
                    <el-button size="mini" style="background-color:#FF1A2E;border-color:#FF1A2E;color:#FFF;"
                        @click="deleteDevice(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page"
            :page-size="search.page_size" layout="total, prev, pager, next" :total="total" background>
        </el-pagination>

        <!-- 创建虚拟设备弹窗 -->
        <el-dialog title="创建虚拟设备" v-model="createDialogVisible" width="600px">
            <el-form :model="createForm" :rules="createRules" ref="createFormRef">
                <el-form-item label="产品型号代码" prop="model_code" label-width="110px">
                    <el-select v-model="createForm.model_code" filterable clearable remote reserve-keyword
                        placeholder=" " :remote-method="getModelList" :loading="modelLoading">
                        <el-option v-for="item in modelOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="C端用户ID" prop="uid" label-width="110px">
                    <el-input v-model="createForm.uid" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" prop="name" label-width="110px">
                    <el-input v-model="createForm.name" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="createDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="createDevice" :loading="createLoading">确 定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    name: 'virtualdevice',
    data() {
        return {
            search: { uid: '', page: 1, page_size: 20 },
            list: [],
            total: 0,
            createDialogVisible: false,
            createLoading: false,
            createForm: { model_code: '', uid: '', name: '' },
            createRules: {
                model_code: [{ required: true, message: '请选择产品型号', trigger: 'change' }],
                uid: [{ required: true, message: '请输入C端用户ID', trigger: 'blur' }]
            },
            modelOptions: [],
            modelLoading: false
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.search.page = val
            sessionStorage.setItem('currentPage', val)
            this.Search()
        },
        Search() {
            const params = { page: this.search.page, page_size: this.search.page_size }
            if (this.search.uid) params.uid = this.search.uid
            this.api.VirtualDeviceList(params).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.data || []
                    this.total = (res.data.data.page_info && res.data.data.page_info.total) || 0
                    return
                }
                this.$message.error('获取列表失败：' + res.data.msg)
            })
        },
        showCreateDialog() {
            this.createForm = { model_code: '', uid: '', name: '' }
            this.createDialogVisible = true
            this.getModelList()
        },
        getModelList(query) {
            this.modelLoading = true
            this.api.ProductModelList({
                page: 1,
                limit: 1000,
                model: query || ''
            }).then(res => {
                this.modelLoading = false
                if (res.data.code == 200) {
                    this.modelOptions = (res.data.data.data || [])
                        .filter(item => item.model_type == 3)
                        .map(item => ({
                            value: item.code,
                            label: item.code
                        }))
                    return
                }
                this.$message.error('获取型号列表失败：' + res.data.msg)
            }).catch(() => { this.modelLoading = false })
        },
        createDevice() {
            this.$refs.createFormRef.validate(valid => {
                if (!valid) return
                this.createLoading = true
                const params = { model_code: this.createForm.model_code, uid: this.createForm.uid }
                if (this.createForm.name) params.name = this.createForm.name
                this.api.VirtualDeviceCreate(params).then(res => {
                    this.createLoading = false
                    if (res.data.code == 200) {
                        this.$message.success('创建成功，UUID: ' + res.data.data.uuid)
                        this.createDialogVisible = false
                        this.Search()
                        return
                    }
                    this.$message.error('创建失败：' + res.data.msg)
                }).catch(() => { this.createLoading = false })
            })
        },
        startDevice(row) {
            this.api.VirtualDeviceStart({ uuid: row.uuid }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('启动成功')
                    this.Search()
                    return
                }
                this.$message.error('启动失败：' + res.data.msg)
            })
        },
        stopDevice(row) {
            this.$confirm('确定停止该虚拟设备？', '提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
            }).then(() => {
                this.api.VirtualDeviceStop({ uuid: row.uuid }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('停止成功')
                        this.Search()
                        return
                    }
                    this.$message.error('停止失败：' + res.data.msg)
                })
            }).catch(() => { })
        },
        deleteDevice(row) {
            this.$confirm('确定删除该虚拟设备？删除后将清理所有关联数据。', '提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
            }).then(() => {
                this.api.VirtualDeviceDelete({ uuid: row.uuid, uid: row.owner_uid }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('删除成功')
                        this.Search()
                        return
                    }
                    this.$message.error('删除失败：' + res.data.msg)
                })
            }).catch(() => { })
        },
        clearCondition() {
            this.search.uid = ''
            this.Search()
        },
        getSchoolWebModuleMessageListFunc() {
            setTimeout(() => {
                if (sessionStorage.getItem("currentPage") && sessionStorage.getItem("currentPage") !== 1) {
                    this.search.page = Number(sessionStorage.getItem("currentPage"))
                }
                this.Search()
            }, 0)
        }
    },
    mounted() {
        this.getSchoolWebModuleMessageListFunc()
    }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    .search {
        background: #F0F2F5;
        padding-top: 16px;
        margin-bottom: 24px;
    }
    .el-form {
        ::v-deep(.el-form-item__label) {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
            padding-right: 0px;
        }
        .el-form-item {
            margin-left: 24px;
        }
    }
    .btnClass {
        color: #FFF;
        background-color: #FB6D07;
        border-color: #FB6D07;
    }
    .textBtn {
        color: #FB6D07;
    }
    ::v-deep(thead) {
        font-family: 'Manrope';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #000;
        opacity: 0.8;
        th {
            font-weight: 400;
            background-color: #F0F2F5;
        }
    }
    ::v-deep(tbody) {
        tr {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
        }
    }
}
</style>